<!--
  IMPORTANT NOTE:
  - Do not change any help screen or help option contents unless at PSMFC's request
-->

<!-- Top bar -->
<mat-toolbar class="topBar"
             color="#005d87">

  <!-- Back to previous screen (either Help or Home) -->
  <button mat-icon-button
          class="example-icon"
          type="button"
          aria-label="Example icon-button with menu icon"
          [matTooltip]="'Back to ' + prevHeader"
          matTooltipPosition="below"
          (click)="toPrevScreen()">
    <mat-icon>
      arrow_back
    </mat-icon>
  </button>

  <!-- Back to Home -->
  <button mat-icon-button
          class="example-icon"
          type="button"
          matTooltip="Back to Home"
          matTooltipPosition="below"
          (click)="router.navigate(['menu'])">
    <mat-icon>
      home
    </mat-icon>
  </button>

  <!-- Page title -->
  <span class="help-title">
    Help - {{currHeader}}
  </span>
</mat-toolbar>

<!-- Container -->
<div class="container help-container" style="max-width: none;">

  <!-- Image view -->
  <div *ngIf="viewerOpen" class="viewer-container">
    <button mat-mini-fab
            class="close-viewer"
            type="button"
            color="warn"
            matTooltip="Close Image"
            matTooltipPosition="below"
            (click)="viewerOpen = false">
      <mat-icon>
        close
      </mat-icon>
    </button>
    <img class="main-img"
         [src]="currImg" />
  </div>

  <!-- Top header -->
  <h1 class="display-3 help-header">
    {{currHeader}}
  </h1>

  <!-- Contents -->
  <div *ngIf="currIndex === -1">

    <mat-selection-list [multiple]="false" hideSingleSelectionIndicator="true">
      <mat-divider></mat-divider>
      <div *ngFor="let item of listItems; let index=index;">
        <mat-list-option (click)="helpOptionClick(item, index)">
          <span class="list-item">
            {{item}}
          </span>
        </mat-list-option>
        <mat-divider></mat-divider>
      </div>
    </mat-selection-list>

  </div>

  <!-- Use the Help Form -->
  <app-help-form *ngIf="currIndex === 0"
                 (backToHelp)="toPrevScreen()">

  </app-help-form>

  <!-- Quick Guide -->
  <app-help-guide *ngIf="currIndex === 1"
                  [website]="website"
                  [linkType]="linkType">

  </app-help-guide>

  <!-- Download the App -->
  <app-help-download *ngIf="currIndex === 2"
                     [website]="website"
                     [linkType]="linkType"
                     [getImgs]="downloadImgsInput"
                     (showImg)="showImage($event)">

  </app-help-download>

  <!-- Create an Account -->
  <app-help-account *ngIf="currIndex === 3"
                    [getImgs]="accountImgsInput"
                    (showImg)="showImage($event)">

  </app-help-account>

  <!-- Main Menu -->
  <app-help-menu *ngIf="currIndex === 4"
                 [getImgs]="menuImgsInput"
                 (showImg)="showImage($event)">

  </app-help-menu>

  <!-- Sets and Catch -->
  <app-help-sets *ngIf="currIndex === 5"
                 [getImgs]="setsImgsInput"
                 (showImg)="showImage($event)">

  </app-help-sets>

  <!-- Current Delivery -->
  <app-help-delivery *ngIf="currIndex === 6"
                     [getImgs]="deliveryImgsInput"
                     (showImg)="showImage($event)">

  </app-help-delivery>

  <!-- Logbook Submission -->
  <app-help-logbook *ngIf="currIndex === 7"
                    [getImgs]="logbookImgsInput"
                    (showImg)="showImage($event)">

  </app-help-logbook>

  <!-- HMS Logbook Data -->
   <app-help-hms *ngIf="currIndex === 8"
                         [getImgs]="hmsImgsInput"
                         (showImg)="showImage($event)">
    </app-help-hms>

  <!-- Common Questions About What Data to Enter -->
  <app-help-questions *ngIf="currIndex === 9">

  </app-help-questions>

  <!-- Add Vessels or Check for updates -->
  <app-help-vessels *ngIf="currIndex === 10">

  </app-help-vessels>

  <!-- Update your email or phone number -->
  <app-help-update *ngIf="currIndex === 11">

  </app-help-update>

  <!-- Get Additional Help -->
  <app-help-additional *ngIf="currIndex === 12"
                       [email]="email">

  </app-help-additional>

  <app-help-geolocation *ngIf="currIndex === 13"
                        [getImgs]="enableGeolocationInput"
                        (showImg)="showImage($event)">

  </app-help-geolocation>

  <app-help-editing-logbook *ngIf="currIndex === 14"
                            [getImgs]="logbookEditingInput"
                            (showImg)="showImage($event)">
  </app-help-editing-logbook>
                            

</div>
